var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tit-wrap centered"
  }, [_c('small', [_vm._v("INTRODUCE US")]), _c('h2', {
    staticClass: "text-60 text-lg-50 text-md-34"
  }, [_vm._v("사업개요")])]);
}]

export { render, staticRenderFns }